import { companyCountries } from "./companyCountries";

// Single source of truth for booking status labels/colours.
// Status codes come from the backend; 9 (Received At Port) was added later,
// so it sits between 4 (Shipped) and 5 (Received At Warehouse) in flow order.
// Warehouse labels name the signed-in company's countries, so they are read when used (getters).

export const BOOKING_STATUS = {
  0: { label: "Booked", color: "#64748b" },
  1: { label: "Assigned", color: "#d97706" },
  2: { label: "Picked Up", color: "#ea580c" },
  3: { get label() { return `In ${companyCountries().pickup} Warehouse`; }, color: "#92400e" },
  4: { label: "Shipped", color: "#2563eb" },
  9: { label: "Received At Port", color: "#0891b2" },
  5: { get label() { return `Received At ${companyCountries().delivery} Warehouse`; }, color: "#4f46e5" },
  6: { label: "Out For Delivery", color: "#0d9488" },
  8: { label: "Partially Delivered", color: "#ca8a04" },
  7: { label: "Delivered", color: "#16a34a" },
  "-1": { label: "Cancelled", color: "#dc2626" },
};

// Pickup area first, then delivery area, Cancelled always last (see bookingStatusGroups for country names)
export const BOOKING_STATUS_GROUPS = [
  { key: "pickup", label: "Pickup", statuses: [0, 1, 2, 3] },
  { key: "delivery", label: "Delivery", statuses: [4, 9, 5, 6, 8, 7] },
  { key: "other", label: "", statuses: [-1] },
];

// Local delivery bookings (is_delivery = 1, Shop orders, delivered in the pickup country) only go Booked -> Assigned -> Delivered
export const LOCAL_DELIVERY_STATUS = {
  0: { label: "Booked", color: "#64748b" },
  1: { label: "Out For Delivery", color: "#0d9488" },
  7: { label: "Delivered", color: "#16a34a" },
  "-1": { label: "Cancelled", color: "#dc2626" },
};

export const LOCAL_DELIVERY_STATUS_GROUPS = [
  { key: "delivery", label: "Shop Orders", statuses: [0, 1, 7] },
  { key: "other", label: "", statuses: [-1] },
];

export const isLocalDelivery = (booking) => parseInt(booking?.is_delivery) === 1;

export const getBookingStatus = (status, localDelivery = false) => (localDelivery ? LOCAL_DELIVERY_STATUS[status] : null) || BOOKING_STATUS[status] || null;

// Group headings with the company's countries, e.g. "Pickup (UK)" / "Delivery (Ghana)"
export const bookingStatusGroups = (countries) => BOOKING_STATUS_GROUPS.map((g) => (
  g.key === "pickup" ? { ...g, label: `Pickup (${countries.pickup})` }
    : g.key === "delivery" ? { ...g, label: `Delivery (${countries.delivery})` }
      : g
));
